import React from 'react';

const CHUNK_RELOAD_GUARD_KEY = 'repair-lab:chunk-reload-attempted';

/**
 * Wraps React.lazy import with a single hard-refresh retry for chunk load failures.
 * This fixes stale cached chunk references after a fresh deploy/build.
 */
export function lazyWithRetry<T extends React.ComponentType<any>>(
  importer: () => Promise<{ default: T }>,
): React.LazyExoticComponent<T> {
  return React.lazy(async () => {
    try {
      const component = await importer();
      sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY);
      return component;
    } catch (error) {
      const message = String((error as Error)?.message || '').toLowerCase();
      const isChunkError =
        message.includes('chunkloaderror') ||
        message.includes('loading chunk') ||
        message.includes('failed to fetch dynamically imported module');
      const alreadyRetried = sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) === '1';

      if (isChunkError && !alreadyRetried) {
        sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, '1');
        window.location.reload();
      }

      throw error;
    }
  });
}
